import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Main from "../Main";
import About from "../pages/About";
import Services from "../pages/Services";
import Works from "../pages/Works";
import Portfolio from "../pages/Portfolio";
import Packages from "../pages/Packages";
import Privacy from "../pages/Privacy";
import ContactForm from "../pages/ContactForm";
import Thankyou from "../pages/Thankyou";
import Header from "../components/Header";
import { AnimatePresence } from "framer-motion";
import Select from "../Select";
import Support from "../pages/Support";


function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route index element={<Select />} />
        <Route path="/support" element={<Support />} />
        <Route
          path="/*"
          element={
            <>
              <Header />
              <Routes>
                <Route path="/it" element={<Main />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/works" element={<Works />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contactform" element={<ContactForm />} />
                <Route path="/thankyou" element={<Thankyou />} />
              </Routes>
            </>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
